<template>
    <div class="page-content header-clear-medium">

        <div class="card card-style" style="margin: 0px 15px 30px 15px;">
			<div class="content">
				<ReportFilter 
					:type-filter.sync="bukuTamuTypeFilter" 
					:daily-time.sync="bukuTamuDailyTime" 
					:monthly-time.sync="bukuTamuMonthlyTime" 
					:range-date-from.sync="bukuTamuRangeDateFrom" 
					:range-date-to.sync="bukuTamuRangeDateTo" 
					@set-type-filter="setDataFilter()"
				/>

				<div class="row mt-3">
					<div class="col-lg-12">
						<button class="btn bg-green-light w-100" @click="getDataBukuTamu()">Cari</button>
					</div>
				</div>

				<!-- <div class="row">
					<div class="col-12 col-md-5 pe-0">
						<div class="form-custom form-label form-border form-icon mb-0">
							<i class="bi bi-sliders font-13"></i>
							<select v-model="mutatedTypeSearchFilter" class="form-select rounded-xs" id="c6" aria-label="Label Search">
								<option value="executive" selected="">Kepala Sekolah</option>
								<option value="search">Semua Data</option>
							</select>
						</div>
					</div>
					<div class="col-12 col-md-7 pe-0">
						<div class="form-custom form-label form-border form-icon mb-3">
							<i class="bi bi-person-circle font-14"></i>
							<input type="text" v-model="searchFilter" class="form-control rounded-xs" id="c1" placeholder="Cari Data" />
						</div>
					</div>
				</div> -->
			</div>
		</div>

		<div v-if="loading">
			<SchoolGuestSekeleton :count="3" />
		</div>
		<div v-else>
			<div v-if="buku_tamu_all.length == 0" class="card card-style" style="background-color: #ffc8d5 !important;">
				<div class="content">
					<strong>Data Kosong!</strong>
				</div>
			</div>

			<div v-if="buku_tamu_all.length > 0" class="content">
				<div v-for="(itemGroupingBukuTamus, indexGrouping) in dataGroupingBukuTamus" :key="indexGrouping">
					<h4 class="text-center mb-3"><span class="badge bg-mint-dark color-white">{{ indexGrouping.replaceAll('-', ' ') }}</span></h4>

					<div v-for="(bukuTamu, indexBukuTamu) in itemGroupingBukuTamus" :key="bukuTamu.id" @click="handleBukuTamuSelected(bukuTamu)" class="d-flex cursor-pointer">
						<div class="align-self-top me-3">
							<span class="icon gradient-blue color-white icon-m rounded-xs">{{ indexBukuTamu + 1 }}</span>
						</div>
						<div :id="`containerBukuTamuDetail${bukuTamu.id}`" class="card card-style w-100 mx-0" :class="{ 'bg-fade-yellow' : !bukuTamuReadLocal.includes(bukuTamu.id) }">
							<div class="content">
								<div class="d-flex flex-sm-column-custom">
									<div class="align-self-top me-3">
										<img 
											:src="bukuTamu.url_photo" 
											class="me-2 rounded-xs border border-4 border-gray-dark" 
											width="100"
										>
										<!-- <span class="icon icon-xxl gradient-blue color-white rounded-m"><i class="bi bi-calendar3 font-28"></i></span> -->
									</div>
									<div class="mt-sm-20">
										<p class="mt-0 mb-1 font-16"><span class="font-700">Nama</span> : {{ bukuTamu.nama }}</p>
										<!-- <p class="mt-0 mb-1 font-16"><span class="font-700">Tujuan</span> : {{ bukuTamu.keperluan }}</p> -->
										<p class="mt-0 mb-1 font-16"><span class="font-700">Alamat</span> : {{ bukuTamu.alamat }}</p>
										<p class="mt-0 mb-1 font-16"><span class="font-700">Instansi</span> : {{ bukuTamu.instansi }}</p>
										<p class="mt-0 mb-1 font-16"><span class="font-700">Keperluan</span> : {{ bukuTamu.keperluan }}</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- <div class="content">
				<div class="d-flex">
					<div class="align-self-top me-3">
						<span class="icon gradient-blue color-white icon-m rounded-xs">1</span>
					</div>
					<div class="card card-style w-100 mx-0">
						<div class="content">
							<div class="d-flex">
								<div class="align-self-top me-3">
									<img 
										src="https://www.mecgale.com/wp-content/uploads/2017/08/dummy-profile.png" 
										class="me-2 rounded-xs border border-4 border-gray-dark" 
										width="100"
									>
								</div>
								<div>
									<p class="mt-0 mb-1 font-16"><span class="font-700">Nama</span> : M. Royidi</p>
									<p class="mt-0 mb-1 font-16"><span class="font-700">Tujuan</span> : H. Mujib Rosyadi, M.Pd</p>
									<p class="mt-0 mb-1 font-16"><span class="font-700">Alamat</span> : Banyuwangi</p>
									<p class="mt-0 mb-1 font-16"><span class="font-700">Instansi</span> : Dinas Pendidikan</p>
									<p class="mt-0 mb-1 font-16"><span class="font-700">Keperluan</span> : bertemu KS</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="d-flex">
					<div class="align-self-top me-3">
						<span class="icon gradient-blue color-white icon-m rounded-xs">2</span>
					</div>
					<div class="card card-style w-100 mx-0 bg-fade-yellow">
						<div class="content">
							<div class="d-flex">
								<div class="align-self-top me-3">
									<img 
										src="https://www.mecgale.com/wp-content/uploads/2017/08/dummy-profile.png" 
										class="me-2 rounded-xs border border-4 border-gray-dark" 
										width="100"
									>
								</div>
								<div>
									<p class="mt-0 mb-1 font-16"><span class="font-700">Nama</span> : M. Royidi</p>
									<p class="mt-0 mb-1 font-16"><span class="font-700">Tujuan</span> : H. Mujib Rosyadi, M.Pd</p>
									<p class="mt-0 mb-1 font-16"><span class="font-700">Alamat</span> : Banyuwangi</p>
									<p class="mt-0 mb-1 font-16"><span class="font-700">Instansi</span> : Dinas Pendidikan</p>
									<p class="mt-0 mb-1 font-16"><span class="font-700">Keperluan</span> : bertemu KS</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div> -->
		</div>

		<Portal to="offcanvas-modal-bottom" :order="1">
			<div v-show="showModalBukuTamuSelected" data-bs-backdrop="false" class="offcanvas-custom offcanvas offcanvas-bottom rounded-m offcanvas-detached bg-theme show" style="visibility: visible;" id="offcanvas-pkb-data">
                <div class="content">
                    <div class="d-flex pb-2">
                        <div class="align-self-center">
                            <h5 class="mb-n1 font-12 color-highlight font-700 text-uppercase pt-1">Detail Tamu</h5>
                        </div>
                        <div class="align-self-center ms-auto">
                            <a @click="handleBukuTamuModalClose" href="javascript:void(0)" class="icon icon-m"><i class="bi bi-x-circle-fill color-red-dark font-18 me-n4"></i></a>
                        </div>
                    </div>

                    <div class="content">
						<div class="d-flex flex-sm-column-custom">
							<div class="mb-3 me-3">
								<img :src="bukuTamuSelected.url_photo" class="img-fluid rounded-s" style="width: 100px; height: 100px; object-fit: fill;">
							</div>
							<div class="me-auto">
								<div class="align-self-center">
									<h5 class="mb-2 font-16">{{ bukuTamuSelected.hasOwnProperty("nama") ? bukuTamuSelected.nama : null }}</h5>

									<!-- <p class="mt-0 mb-1 font-16"><span class="font-700">Tujuan</span> : {{ bukuTamu.keperluan }}</p> -->
									<p class="mt-0 mb-1 font-16"><span class="font-700">Alamat</span> : {{ bukuTamuSelected.hasOwnProperty("alamat") ? bukuTamuSelected.alamat : null }}</p>
									<p class="mt-0 mb-1 font-16"><span class="font-700">Instansi</span> : {{ bukuTamuSelected.hasOwnProperty("instansi") ? bukuTamuSelected.instansi : null }}</p>
									<p class="mt-0 mb-1 font-16"><span class="font-700">Keperluan</span> : {{ bukuTamuSelected.hasOwnProperty("keperluan") ? bukuTamuSelected.keperluan : null }}</p>
								</div>
							</div>
						</div>
					</div>

					<a href="javascript:void(0)" @click="handleBukuTamuModalClose" class="btn btn-full btn-s bg-red-dark">Tutup</a>
                </div>
            </div>
			<div v-show="showModalBukuTamuSelected" class="offcanvas-backdrop fade show"></div>
        </Portal>

		<Portal to="offcanvas-modal-bottom" :order="2">
			<div v-show="showModalPluginExist" id="offcanvas-subject-class-delete" data-bs-scroll="false" data-bs-backdrop="false" style="visibility: visible;" class="offcanvas offcanvas-bottom rounded-m offcanvas-detached show">
				<div class="bg-yellow-dark px-3 py-3">
					<div class="d-flex mt-1">
						<div class="align-self-center">
							<h1 class="font-800 color-white mb-0">Pemberitahuan</h1>
						</div>
					</div>
					<p class="color-white opacity-80 pt-2">
						Bukutamu Belum di Install atau di Aktifkan
					</p>
					<router-link :to="{ name: 'home' }" class="default-link btn btn-full btn-s bg-white color-black">Oke, Paham!</router-link>
				</div>
			</div>
			<div v-show="showModalPluginExist" class="offcanvas-backdrop fade show"></div>
        </Portal>
        
    </div>
</template>

<script>
import { 
	mapMutations, 
	mapActions, mapState 
} from 'vuex'
import moment from 'moment'

import ReportFilter from '../components/form/ReportFilter.vue'

import SchoolGuestSekeleton from "../components/skeleton/SchoolGuestSekeleton.vue";

export default {
    name: 'SchoolGuest',
    components: {
		ReportFilter,
		SchoolGuestSekeleton
    },
    data() {
        return {
			bukuTamuTypeFilter: this.$route.query.type ?? 'daily',
			bukuTamuMonthlyTime: this.$route.query.monthly ?? moment().format('MM'),
			bukuTamuDailyTime: this.$route.query.daily ?? moment().format('YYYY-MM-DD'),
			bukuTamuRangeDateFrom: this.$route.query.date_from ?? moment().format('YYYY-MM-DD'),
			bukuTamuRangeDateTo: this.$route.query.date_to ?? moment().format('YYYY-MM-DD'),

			dataDateList : [],
			dataGroupingBukuTamus : {},

			showModalBukuTamuSelected: false,
			bukuTamuSelected: {},

			showModalPluginExist : false,

			// mutatedTypeSearchFilter: 'executive',
			// searchFilter: '',
        }
    },
    async created() {
        // if (this.bukuTamuTypeFilter == 'monthly') {
		// 	this.getDataBukuTamuMonthly()
		// } else {
		// 	this.getDataBukuTamuDaily()
		// }
		await this.getDataBukuTamu()
    },
    methods: {
        ...mapMutations(['SET_LOADING', 'CLEAR_LOADING']),
        ...mapActions('bukuTamu', ['getBukuTamuAll']),
		...mapActions('notificationLocal', ['readBukuTamuNotificaion']),
		setDataFilter(value) {
			this.bukuTamuTypeFilter = value;
		},
		async getDataBukuTamu() {
			this.SET_LOADING();
			switch (this.bukuTamuTypeFilter) {
				case 'monthly':
					await this.getDataBukuTamuMonthly()
					break;
				case 'daily':
					await this.getDataBukuTamuDaily()
					break;
				// case 'all':
				// 	await this.getDataBukuTamuAll()
				// 	break;
				// case 'range':
				// 	await this.getDataBukuTamuRange()
				// 	break;
				default:
					break;
			}
			this.CLEAR_LOADING();
		},
		async getDataBukuTamuDaily() {
			// this.getBukuTamuAll({type: this.bukuTamuTypeFilter, date: this.bukuTamuDailyTime})

			let dataBukuTamus = await this.getBukuTamuAll({type: this.bukuTamuTypeFilter, date: this.bukuTamuDailyTime})
			if (dataBukuTamus.status) {
				this.groupingAnnouncements(dataBukuTamus)
			} else {
				this.showModalPluginExist = true
			}
		},
		async getDataBukuTamuMonthly() {
			// this.getBukuTamuAll({type: this.bukuTamuTypeFilter, date: this.bukuTamuMonthlyTime})

			let dataBukuTamus = await this.getBukuTamuAll({type: this.bukuTamuTypeFilter, date: this.bukuTamuMonthlyTime})
			if (dataBukuTamus.status) {
				this.groupingAnnouncements(dataBukuTamus)
			} else {
				this.showModalPluginExist = true	
			}
		},
		groupingAnnouncements(dataBukuTamus) {
			let tempGroupingBukuTamus = {}
			let arrDateList = []

			dataBukuTamus.data.forEach(element => {
				let tempDate = moment(element.tanggal).format("DD-MMMM-YYYY")
				if (!arrDateList.includes(tempDate)) arrDateList.push(tempDate)
				// tempGroupingBukuTamus[].push(element)
			})
			this.dataDateList = arrDateList
			arrDateList.forEach(element => {
				tempGroupingBukuTamus[element] = []
			})
			dataBukuTamus.data.forEach(element => {
				let tempDate = moment(element.tanggal).format("DD-MMMM-YYYY")
				tempGroupingBukuTamus[tempDate].push(element)
			})

			this.dataGroupingBukuTamus = tempGroupingBukuTamus
		},
		handleBukuTamuSelected(dataBukuTamu) {
			this.readBukuTamuNotificaion(dataBukuTamu.id)
			document.getElementById(`containerBukuTamuDetail${dataBukuTamu.id}`).classList.remove("bg-fade-yellow")

			this.bukuTamuSelected = dataBukuTamu
			this.showModalBukuTamuSelected = true
		},
		handleBukuTamuModalClose() {
			this.bukuTamuSelected = {}
			this.showModalBukuTamuSelected = false
		}
    },
    computed: {
        ...mapState({
            loading: state => state.loading
        }),
        ...mapState('bukuTamu', {
            buku_tamu_all: state => state.buku_tamu_all,
        }),
		...mapState('notificationLocal', {
            bukuTamuReadLocal: state => state.bukuTamuReadLocal,
        }),
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }

@media (max-width: 499px) {
	.flex-sm-column-custom { flex-direction: column; }
	.mt-sm-20 { margin-top: 20px; }
}
</style>
